import React from 'react';
import { images } from 'helpers';
import { CheckCircle } from '@mui/icons-material';

interface Props {
    icon?: boolean;
    color: 'warning' | 'success' | 'danger';
    children: any;
    className?: string;
}
const Alert = ({ icon, color, children, className }: Props) => {
    icon = typeof icon === 'undefined' ? true : false;

    return (
        <React.Fragment>
            <div id="Alert" className={`${icon && 'flex items-center'} font-mediums rounded-[8px] ${color} ${className || 'px-[14px] py-[10px]'}`}>
                {icon && (
                    <div>
                        {color === 'warning' && (
                            <img src={images.Alert} alt="Alert" className="mr-2" />
                        )}
                        {color === 'success' && (
                            <CheckCircle className="mr-2" />
                        )}
                        {color === 'danger' && (
                            <CheckCircle className="mr-2" />
                        )}
                    </div>
                )}
                {children}
            </div>
        </React.Fragment>
    );
};

export default Alert;